import { Footer } from '../../components/Footer';
import { Content } from './Content';
import { Header } from './Header';
import './home.scss';
const slide = {
  imgSrc: '/image/screen1.png',
  title: '秒速开盒，即刻揭晓',
  text: '极简操作流程无需等待，一键抽盒，瞬时解锁时尚数码好物 ',
  width: '40rem',
  height: '45.31rem',
};
export function About() {
  return (
    <div className='main'>

      <Header />
      <div className='wrapper' style={{
        transform: `translate3d(0px, ${-0}px, 0px)`,
        transitionDuration: '0.8s',
        transitionDelay: '0ms',
      }}>

        <div className="page" style={{ backgroundImage: `url(/image/background.png)` }}>
          <div className="wrap" style={{ ['--cover-width' as any]: slide.width, ['--cover-height' as any]: slide.height }}>

            <Content title={slide.title} text={slide.text} />
            <div className='component-describe'>
              <div className='component-describe-title'>关于我们</div>
              <div className='component-describe-value'>
               <div className='value-line'> 怀远模玩文化有限公司成立于2024年，深耕潮流文创新零售领域，是一家集时尚手办、潮流球鞋、轻奢奢侈品、创意盲盒为一体的综合性潮流文化企业。公司立足潮流消费市场需求，精准把握年轻群体消费趋势，以多元化潮流品类为核心，创新盲盒趣味玩法，致力于打造兼具品质、趣味与体验的潮流消费平台，为广大潮流爱好者提供优质、多元的文创消费选择。</div> 
        <div className='value-line'> 自成立以来，公司聚焦四大核心业务板块，构建了完善的潮流产品矩阵。涵盖正版IP时尚手办、热门限量潮鞋、高端轻奢奢侈品以及各类主题创意盲盒，同时持续创新迭代盲盒玩法，打破传统盲盒单一模式，以多样化、趣味性的互动体验，贴合当下年轻消费群体的个性化、潮流化消费需求，积累了海量忠实用户与良好的市场口碑。</div> 
品质与服务是公司的核心发展根基。我们始终坚守三大核心服务优势：正品保障、极速物流、贴心客服关怀。所有产品均严格甄选正品货源，建立全链路品控审核机制，杜绝假冒伪劣产品；搭建高效物流配送体系，实现订单快速响应、极速发货，缩短用户等待周期；组建专业暖心客服团队，全程一对一答疑解惑，高效处理用户咨询、售后等各类问题。未来，公司将持续深耕潮流文创领域，不断丰富产品品类、升级服务体系，创新潮流消费模式，致力于成为国内极具影响力的潮流文创新零售品牌。</div>
            </div>
          </div>
        </div>   
        </div>
            {/* 底部 */}
                <Footer />
    </div>
  );
}
